export const EDIT_ROOM_URL = 'edit-room';
